/*
  Objects Array = [
    {
      ballon: {
        clusterCaption: "List of objects at the coordinates",
        balloonContentHeader,
        balloonContentBody,
        balloonContentFooter
      }
    }
  ]
  EVENTS 
  onClusterClick - returns array of objects at that cluster
  handleClick - return clicked object
*/

import React, { Component } from 'react';
import { FullscreenControl, Map, YMaps, ZoomControl } from 'react-yandex-maps';

import Loading from '../../../components/LoadingCss';

const HEATMAP_SCRIPT_URL = 'https://yastatic.net/s3/mapsapi-jslibs/heatmap/0.0.1/heatmap.min.js';

let heatmapScriptPromise = null;

function loadHeatmapScript() {
  if (!heatmapScriptPromise) {
    heatmapScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = HEATMAP_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        heatmapScriptPromise = null;
        reject(new Error('Не удалось загрузить скрипт Yandex Heatmap'));
      };
      document.body.appendChild(script);
    });
  }
  return heatmapScriptPromise;
}

class YandexHeatMapWrap extends Component {
  _isMounted = false;
  constructor() {
    super();
    this.state = {
      loading: true,
      center: [49.807754, 73.088504],
      objects: [],
    };
    this.clusterer = null;
    this.ymaps = null;
    this.map = null;
  }

  onApiAvaliable = (ymaps) => {
    this.ymaps = ymaps;
    this.tryInitHeatMap();
  };

  setMapControlInstanceRef = (ref) => {
    this.map = ref;
    if (this.map) {
      this.tryInitHeatMap();
    }
    this.setState({ loading: false });
  };

  tryInitHeatMap = () => {
    if (!this.ymaps || !this.map || this.heatmap || this.heatmapLoading) return;
    this.heatmapLoading = true;
    loadHeatmapScript()
      .then(() => this.buildHeatmap())
      .catch((error) => {
        this.heatmapLoading = false;
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };

  buildHeatmap = () => {
    const { ymaps, map } = this;
    const { objects } = this.props;
    ymaps.modules.require(
      ['Heatmap'],
      (Heatmap) => {
        const heatmap = new Heatmap(
          {
            type: 'FeatureCollection',
            features: this.returnMapData(objects),
          },
          {
            radius: 20,
            gradient: {
              0.1: 'rgba(128, 255, 0, 0.7)',
              0.2: 'rgba(255, 255, 0, 0.8)',
              0.7: 'rgba(234, 72, 58, 0.9)',
              1.0: 'rgba(162, 36, 25, 1)',
            },
          }
        );
        heatmap.setMap(map);
        this.heatmap = heatmap;
      },
      (error) => {
        this.heatmapLoading = false;
        // eslint-disable-next-line no-console
        console.error('Не удалось загрузить модуль Heatmap Яндекс.Карт', error);
      }
    );
  };

  refreshHeatmap = () => {
    if (!this.heatmap) return;
    this.heatmap.setData({
      type: 'FeatureCollection',
      features: this.returnMapData(this.state.objects),
    });
  };

  returnFr(val, max) {
    return (100 * val) / max;
  }

  returnMapData(data) {
    const { xDataKey, yDataKey } = this.props;
    const unique_coords = [];
    let arr = data
      .map((item, index) => {
        const x = parseFloat(item[yDataKey]);
        const y = parseFloat(item[xDataKey]);
        if (Number.isNaN(x) || Number.isNaN(y)) return null;
        const coords = x + ' ' + y;
        if (!unique_coords.includes(coords)) {
          unique_coords.push(coords);
          return {
            id: 'id' + index,
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [x, y],
            },
            properties: {
              weight: 1,
            },
          };
        } else return null;
      })
      .filter((e) => e);
    return arr;
  }

  onObjectClick = (obj) => {
    const { idDataKey } = this.props;
    this.props.handleClick(obj[idDataKey]);
    this.changeMapCenter(obj);
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.map) {
      this.map.destroy();
    }
  }

  createGeoObjects = (objects) => {
    const { xDataKey, yDataKey } = this.props;
    let geoObjects = [];
    if (!objects[0]) return [];
    objects.forEach((el) => {
      let coords = [el[yDataKey], el[xDataKey]];
      if (coords) {
        let obj = new this.ymaps.Placemark(coords, el.ballon, {
          iconColor: el.color ? el.color : '#3caa3c',
          preset: 'islands#circleIcon',
        });
        obj.dataObject = el;
        obj.events.add('click', () => {
          this.onObjectClick(el);
        });
        geoObjects.push(obj);
      }
    });
    return geoObjects;
  };

  onClustererClick = (ev) => {
    if (!ev.get('target').dataObject) {
      const objects = ev
        .get('target')
        .getGeoObjects()
        .map((el) => el.dataObject);
      if (this.props.onClusterClick) {
        this.props.onClusterClick(objects);
      }
    }
  };

  createCluster = () => {
    const clusterer = new this.ymaps.Clusterer({
      hasBalloon: false,
      clusterDisableClickZoom: true,
      clusterIconLayout: 'default#pieChart',
      clusterIconPieChartRadius: 25,
      clusterIconPieChartCoreRadius: 10,
      clusterIconPieChartStrokeWidth: 3,
      groupByCoordinates: false,
    });
    clusterer.events.add('click', (e) => {
      this.onClustererClick(e);
    });
    let geoObjects = this.createGeoObjects(this.state.objects);
    if (geoObjects[0]) clusterer.add(geoObjects);
    this.clusterer = clusterer;
    if (this.map) this.map.geoObjects.add(clusterer);
  };

  componentDidUpdate() {
    if (this.state.objects.length !== this.props.objects.length && this._isMounted) {
      this.setState(
        {
          objects: this.props.objects,
        },
        () => {
          if (this.clusterer) this.refreshClusterer();
          if (this.heatmap) this.refreshHeatmap();
          if (!this.props.showDefaultCity) this.changeMapCenter(this.props.objects[0]);
        }
      );
    }
  }

  changeMapCenter = (el) => {
    const { xDataKey, yDataKey } = this.props;
    let coords = [el[yDataKey], el[xDataKey]];
    this.setState({ center: coords });
  };

  refreshClusterer = () => {
    this.clusterer.removeAll(); // Delete all geoObjects
    let geoObjects = this.createGeoObjects(this.state.objects);
    if (geoObjects[0]) {
      this.clusterer.add(geoObjects); // Add new GeoObjeccts
    }
  };

  render() {
    let { height, zoom = 7 } = this.props;
    return (
      <React.Fragment>
        {this.state.loading && <Loading />}
        <YMaps query={{ lang: 'ru_RU', ns: 'ymaps' }}>
          <Map
            onLoad={this.onApiAvaliable}
            state={{
              center: this.state.center,
              zoom: zoom,
              controls: [],
            }}
            width="100%"
            height={height ? height : '55vh'}
            instanceRef={this.setMapControlInstanceRef}
          >
            <ZoomControl
              options={{
                size: 'small',
                zoomDuration: 1000,
              }}
            />
            <FullscreenControl />
          </Map>
        </YMaps>
      </React.Fragment>
    );
  }
}

export default YandexHeatMapWrap;
